import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { API_DOCS_PATH } from './paths';

/**
 * `/api-docs` (the disabled `page:api-docs`) redirects to the Catálogo
 * APIs tab. No title or icon, so it is not a menu item; the menu's "APIs"
 * item lives in the side menu (modules/nav).
 */
export const apiDocsRedirectPage = PageBlueprint.make({
  name: 'api-docs-redirect',
  params: {
    path: API_DOCS_PATH,
    noHeader: true,
    loader: () => import('./ApiDocsRedirect').then(m => <m.ApiDocsRedirect />),
  },
});

export const apisModule = createFrontendModule({
  pluginId: 'app',
  extensions: [apiDocsRedirectPage],
});
